/* src/app/core/guards/not-found/not-found.component.scss */
.not-found-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f5f7fb;
}
.not-found-card {
  width: 100%;
  max-width: 560px;
  background: #ffffff;
  border-radius: 12px;
  padding: 28px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
}
.not-found-card h1 {
  margin: 0 0 12px;
  font-size: 28px;
  line-height: 1.2;
  color: #1f2937;
}
.not-found-card p {
  margin: 0 0 24px;
  color: #4b5563;
  font-size: 16px;
  line-height: 1.5;
}
.btn-login {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 500;
  border-radius: 6px;
  padding: 0.6rem 1.2rem;
  font-size: 0.9rem;
  height: 40px;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid transparent;
  line-height: normal;
  box-sizing: border-box;
}
.primary {
  background-color: var(--cf-brand);
  color: rgba(0, 0, 0, 0.85);
  border-color: var(--cf-brand);
}
.primary:hover {
  background-color: var(--cf-brand-dark);
  border-color: var(--cf-brand-dark);
  color: #fff;
}
/*# sourceMappingURL=not-found.component.css.map */
